// When each live message was sent (a question) or finished (an answer), for the life of the page. It lives
// in the page, not the thread: opening a saved chat unmounts the thread, and a remount must not restamp
// every message with the moment the reader came back. The SDK's messages carry no time of their own.

import { useRef } from "react";
import { stampTimes } from "./messageTime.mjs";

export default function useMessageTimes(messages) {
  const ref = useRef({});
  ref.current = stampTimes(ref.current, messages);
  return ref.current;
}
